import styled, { css } from "styled-components";
import { FlexRow, FlexCenter } from "app-styled/flex";
import { device } from "@core-const";
import { LinkButton } from "app-styled/link";

const LocationSearchWrapper = styled(FlexRow)`
  padding-right: 0;
  //   width: 50%;
  height: 60px;

  @media ${device.laptop} {
    width: 100%;
    ${({ theme }) => css`
      border-radius: 6px;
    `}
  }
`;
const LocationWrapper = styled.div`
  height: 100%;
  //   width: calc(100% - 153px);
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  background-color: white;
  ${({ theme }) => css`
    color: ${theme["component-text"]};
    font-size: 1.3rem;

    @media ${device.laptop} {
      border-radius: ${theme["thm-radius"]};
      border-radius: ${theme["thm-radius"]};
    }

    @media ${device.mobileL} {
      border-radius: ${theme["thm-radius"]};
      border-radius: ${theme["thm-radius"]};
    }
  `}
  ${({ theme, fullWidth }) =>
    fullWidth &&
    css`
      @media ${device.tablet} {
        width: 100%;
      }
    `};
`;

const LocationSearch = styled.input`
  width: 100%;
  height: 100%;
  border: none;
  ${({ theme, width }) => css`
    color: ${theme["component-text"]};
    font-size: 1.3rem;
    padding: 0 ${theme["space-sm"]};
    width: ${width};
    background-color: white;
    border: 1px solid #ced4da;
    color: #495057;
    border-radius: 0.25rem;
    box-shadow: none !important;

    &:hover {
      border-color: ${theme["smylor-light-blue"]} !important;
    }
    &:focus-within {
      border-color: ${theme["smylor-light-blue"]} !important;
      box-shadow: 0 0 0 0.05rem ${theme["smylor-light-blue"]} !important;
    }

    @media ${device.laptop} {
      width: 100%;
      padding: 0 16px !important;
      //   border-bottom-left-radius:${theme["thm-radius"]};
      //   border-top-left-radius:${theme["thm-radius"]};
    }
  `}
`;

const SearchBtn = styled(FlexCenter)`
  height: 100%;
  width: 100px;
  font-size: 2rem;
  ${({ theme }) => css`
    color: ${theme["component-text"]};
    background-color: ${theme.highlight};
    padding: 0 ${theme["space-sm"]};
    font-family: ${theme["font-bold"]};
    @media ${device.tablet} {
      width: 100%;
      margin: ${theme["margin-elementSmall"]} 0;
    }
  `}
`;

const LocationDrop = styled.div`
  position: absolute;
  top: 60px;
  width: 100%;
  display: flex;
  flex-direction: column;
  max-height: 300px;
  overflow-y: auto;
  z-index: 999;

  ${({ theme }) => css`
    background-color: ${theme["component-bg"]};
    border-bottom-left-radius: ${theme["thm-radius"]};
    border-bottom-right-radius: ${theme["thm-radius"]};
    box-shadow: ${theme["smylor-light-blueA"]} 0 0 2px,
      ${theme["smylor-light-blueA"]} 0 6px 12px -8px;
  `}

  ${({ btm }) =>
    btm &&
    css`
      bottom: 60px;
      top: unset;
    `}
`;

const LocationData = styled.div`
  cursor: pointer;
  height: 2rem;
  height: auto;
  ${({ theme }) => css`
    padding: ${theme["thm-space-sm"]} ${theme["thm-space-lg"]};
    color: ${theme["component-text"]};
    font-size: ${theme["thm-font-lg"]};
    svg {
      font-size: ${theme["thm-font-lg"]} !important;
    }
    &:hover {
      background-color: ${theme["smylor-light-blueA"]};
    }
  `}
`;

export const SearchLinkButton = styled(LinkButton)`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;

  ${({ theme }) => css`
    @media ${device.tablet} {
      padding: ${theme["thm-space-lg"]} ${theme["thm-space-lg"]};
      padding-left: ${theme["thm-space-md"]};
    }
  `}
`;

export const SearchContent = styled(FlexRow)`
  //   width: 50%;
  height: 60px;

  @media ${device.laptop} {
    width: 100%;
    border-radius: 6px;
    overflow: hidden;
  }
`;

export {
  LocationSearchWrapper,
  LocationWrapper,
  LocationSearch,
  SearchBtn,
  LocationDrop,
  LocationData,
};
